import {Expose, Type} from 'class-transformer';
import {AbstractApiModel} from './abstract.api.model';
import {PlaceCategoryApiModel} from './place-category.api-model';
import {MediaObjectApiModel} from './media-object.api-model';

export interface PlaceAddressApiModel { place?: string; coordinates?: number[]; city?: {name?: string; coordinates?: number[]}; country?: {name?: string}; }
export interface PlaceReviewIssueApiModel { id: number; content: string; position: number; }

export class PlaceApiModel extends AbstractApiModel {
  @Expose() id: number;
  @Expose() name: string;
  @Expose() nameTranslations?: Record<string, string>;
  @Expose() slug: string;
  @Expose() description: string;
  @Expose() accessNote?: string;
  @Expose() status: 'PENDING'|'CHANGES_REQUESTED'|'PUBLISHED'|'REJECTED';
  @Expose() @Type(() => PlaceCategoryApiModel) category?: PlaceCategoryApiModel;
  @Expose() address?: PlaceAddressApiModel;
  @Expose() @Type(() => MediaObjectApiModel) cover?: MediaObjectApiModel;
  @Expose() averageRating?: number;
  @Expose() ratingsCount?: number;
  @Expose() currentUserRating?: number;
  @Expose() checkInsCount?: number;
  @Expose() reviewedAt?: string;
  @Expose() rejectionNoticeDismissedAt?: string;
  @Expose() createdBy?: {username?: string; email?: string};
  @Expose() @Type(() => Object) reviewIssues?: PlaceReviewIssueApiModel[];
}
